export const fetchConversionRates = async (setMxnValue, setUsdValue) => {
	if (!setMxnValue || !setUsdValue) return;

	try {
		const response = await fetch(process.env.REACT_APP_RATES_API_URL);

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		const mxn = data?.bitcoin?.mxn;
		const usd = data?.bitcoin?.usd;

		if (mxn && usd) {
			setMxnValue(mxn);
			setUsdValue(usd);
		} else {
			console.warn('Missing currency data in response:', data);
		}
	} catch (error) {
		console.error('Error fetching conversion rates:', error);
	}
};

export const handleCurrencyChange = (setCurrentCurrency) => {
	setCurrentCurrency((prev) =>
		prev === 'SATS'
			? 'USD'
			: prev === 'USD'
			? 'BTC'
			: prev === 'BTC'
			? 'MXN'
			: 'SATS'
	);
};

export const getSatoshis = (sats) => {
	if (!sats) return 0;
	return Intl.NumberFormat('en-US', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(sats);
};

export const satoshiToMxn = (sats, mxnValue) => {
	if (!sats || !mxnValue) return 0;
	const btcValue = sats / 100_000_000;
	const mxnValueFormatted = (btcValue * mxnValue).toFixed(2);
	return new Intl.NumberFormat('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(mxnValueFormatted);
};

export const satoshiToUsd = (sats, usdValue) => {
	if (!sats || !usdValue) return 0;
	const btcValue = sats / 100_000_000;
	const usdValueFormatted = (btcValue * usdValue).toFixed(2);
	return new Intl.NumberFormat('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(usdValueFormatted);
};

export const satoshiToBtc = (sats) => {
	if (!sats) return 0;
	return (sats / 100_000_000).toFixed(8);
};

export const formatBalance = (amount, current, usdValue, mxnValue) => {
	switch (current) {
		case 'SATS':
			return `${getSatoshis(amount)} sats`;
		case 'USD':
			return `$${satoshiToUsd(amount, usdValue)} USD`;
		case 'BTC':
			return `${satoshiToBtc(amount)} BTC`;
		case 'MXN':
			return `$${satoshiToMxn(amount, mxnValue)} MXN`;
		default:
			return `${getSatoshis(amount)} sats`;
	}
};
